import axios from "axios";
import { API_BASE } from "../utils/Constants";
import { getToken, removeUserSession } from "../utils/Auth";
export default (history = null) => {
    const baseURL = API_BASE;

    let headers = {};

    if (getToken()) {
        headers.Authorization = `Bearer ${getToken()}`;
    }

    const axiosInstance = axios.create({
        baseURL: baseURL,
        headers,
    });

    axiosInstance.interceptors.response.use(
        (response) =>
            new Promise((resolve, reject) => {
                resolve(response);
            }),
        (error) => {
            if (!error.response) {
                return new Promise((resolve, reject) => {
                    reject(error);
                });
            }

            /**
             * If history is available, use it to navigate to login. Otherwise, navigate using window.location.
             * In window.location, use redirect parameter to store the path to go to after login.
             */
            const navigateToRootWithRedirect = () => {
                if (history) {
                    history.push({
                        pathname: "/",
                        state: history.location.state
                    });
                    return;
                }

                const currentUrl = new URL(window.location.href);
                const existingRedirect = currentUrl.searchParams.get("redirect");

                // If redirect already exists, don't override it
                if (existingRedirect) {
                    window.location = "/?redirect=" + encodeURIComponent(existingRedirect);
                    return;
                }

                const fullPath =
                    window.location.pathname +
                    window.location.search +
                    window.location.hash;

                if (fullPath && fullPath !== "/") {
                    window.location =
                        "/?redirect=" + encodeURIComponent(fullPath);
                } else {
                    window.location = "/";
                }
            };

            // If the backend explicitly says auth is required, redirect to login
            if (
                error.response.status === 401 &&
                error.response.data &&
                error.response.data.message === "Authentication required"
            ) {
                // Store current path so we can return after successful login
                try {
                    const intendedPath =
                        window.location.pathname + window.location.search + window.location.hash;
                    if (intendedPath && intendedPath !== "/") {
                        sessionStorage.setItem("postLoginRedirect", intendedPath);
                    }
                } catch (_) {
                    // ignore storage errors (private mode, etc.)
                }

                removeUserSession();
                navigateToRootWithRedirect();
                return;
            }

            // Don't redirect to login if we're on a tokenized callDashboard URL
            const isTokenizedCallDashboard = window.location.pathname.startsWith('/callDashboard/') &&
                window.location.pathname.split('/').length === 3;

            if (error.response.status === 401 && !error.response.data.message) {
                if (!isTokenizedCallDashboard) {
                    removeUserSession();
                    navigateToRootWithRedirect();
                } else {
                    return new Promise((resolve, reject) => {
                        reject(error);
                    });
                }
            } else {
                if (
                    error.response.status === 401 &&
                    error.response.data.code === "E_JWT_TOKEN_EXPIRED"
                ) {
                    if (!isTokenizedCallDashboard) {
                        removeUserSession();
                        navigateToRootWithRedirect();
                    } else {
                        return new Promise((resolve, reject) => {
                            reject(error);
                        });
                    }
                } else {
                    return new Promise((resolve, reject) => {
                        reject(error);
                    });
                }
            }
        }
    );

    return axiosInstance;
};
